import { useAtom } from 'jotai';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { p2lTrophyIconPng } from '../assets/images';
import { userAtom } from '../jotai-atoms/user.atom';
import { Modal, ModalProps } from './Modal';

export interface ModalPlay2LearnInvitationProps {
  show: boolean;
  onClose: () => void;
}

export const ModalPlay2LearnInvitation: React.FC<ModalPlay2LearnInvitationProps> = ({
  onClose,
  show,
}) => {
  const [user] = useAtom(userAtom);

  const __ = useTranslation().t;

  const buttonHref = user?.context?.p2lEmbeddedZoomPlayerEnabled
    ? `/v4/help/play2learn-onboarding`
    : `/help/gameclass`;

  const modalProps: ModalProps = {
    show,
    onClose,
    onSubmit: () => {
      window.location.href = buttonHref;
    },
    type: 'play2learn-invitation',
    submitButtonText: __('watchVideo'),
  };

  return (
    <Modal {...modalProps}>
      <div className="oejr-p2l-modal-header">
        <img src={p2lTrophyIconPng} alt="Trophy" />
      </div>
      <div className="oejr-p2l-modal-content">
        <Trans
          alt={__('congratulationsAccessPlay2Learn')}
          i18nKey="congratulationsAccessPlay2Learn"
        >
          <strong>Congratulations!</strong> Now you can access <strong>"Play2Learn"</strong>, the
          new Open English classes to learn while you play. Watch a 2-minute video to learn about
          and be able to book these new classes.
        </Trans>
      </div>
    </Modal>
  );
};
